interface Issue {
  issue: string;
  count: number;
  aspect: string;
}

interface CommonIssuesListProps {
  issues: Issue[];
}

export function CommonIssuesList({ issues }: CommonIssuesListProps) {
  if (issues.length === 0) {
    return <div className="text-sm text-gray-500">No issues found</div>;
  }

  return (
    <div className="space-y-2">
      {issues.map((item, idx) => (
        <div key={idx} className="flex items-center justify-between text-sm">
          <div className="flex items-center gap-2">
            <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600 capitalize">
              {item.aspect}
            </span>
            <span className="text-gray-700">{item.issue}</span>
          </div>
          <span className="text-gray-500 font-medium">{item.count}</span>
        </div>
      ))}
    </div>
  );
}
